/** Floor value to prevent log(0) in logarithmic positioning */
export const WHISKER_CHART_LOG_FLOOR = 0.01;
/** Distance from a chart edge (% of bar width) within which the "You" pill shifts to avoid overflow */
export const WHISKER_EDGE_THRESHOLD = 20;
